<template>
  <v-select
    :items="countries"
    v-model="countrySelected"
    autocomplete
    :label="label"
    :disabled="(defaultCountry) ? true : false"
    :multiple="(multiple) ? true : false"
  />
</template>

<script>
import countriesData from './countries.json'

export default {
  props: ['mode', 'label', 'defaultCountry', 'multiple'],
  data: () => ({
    countrySelected: 'USD'
  }),
  computed: {
    countries () {
      return Object.keys(countriesData).map((key) => {
        return {
          value: key,
          text: `${countriesData[key]} (${key})`
        }
      })
    }
  },
  watch: {
    countrySelected () {
      this.$emit('change', this.countrySelected, this.mode)
    }
  },
  created () {
    if (this.defaultCountry) {
      this.countrySelected = this.defaultCountry
    }
    if (this.multiple) {
      this.countrySelected = ['USD']
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/converter/SelectCurrency.vue